import { Color } from '@persona-id/design-tokens';
import { SearchIcon } from '@persona-id/design-tokens/icons/24px';
import { useRef } from 'react';
import styled from 'styled-components';

import Input, { InputGroup } from 'design-system/components/Input';

// This component is used in the Navbar as the click target to open the OmnisearchModal
const OmnisearchTargetInput = ({ onFocus }: { onFocus: () => void }) => {
  const omnisearchInput = useRef(null);

  return (
    <InputWrapper>
      <InputGroup id='omnisearch-input-target-wrapper' size='md' leftIcon={<SearchIcon />}>
        <Input
          id='omnisearch-input-target'
          name='omnisearch-input-target'
          ref={omnisearchInput}
          tabIndex={-1}
          aria-label='omnisearch-input-target'
          aria-describedby='omnisearch-input-target'
          placeholder='Search or ask...'
          width='100%'
          onFocus={() => {
            // Must blur after focus to allow the OmnisearchModal to be closed
            onFocus();
            /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
            omnisearchInput.current.blur();
          }}
        />
      </InputGroup>
    </InputWrapper>
  );
};

const InputWrapper = styled.div`
  input {
    border-color: ${Color.BorderDivider};
  }
  width: 100%;
`;

export default OmnisearchTargetInput;
